import { useFormik } from "formik";
import { useEffect } from "react";
import { convertToFilter, makeObservable } from "../../../util";
import { createSearchResultNavigationStore } from "../../../util/searchResultNavigation";

// observable store
const warehouseFilterStore = makeObservable({});
const warehouseNavigationStore = createSearchResultNavigationStore();

const useWarehouseFilters = () => {
  const formik = useFormik({
    initialValues: {
      categoryId: {
        operator: "in",
      },
      destroyed: 0,
      limit: 50,
      offset: 0,
      tab: "instance",
    },
  });

  const filterKeys = ["tab"];

  const skipKeys = ["limit", "offset"];

  useEffect(() => {
    // convert formik values to filter and update store
    warehouseFilterStore.set(
      convertToFilter({ values: formik.values, filterKeys, skipKeys }),
    );
  }, [formik.values]);

  return {
    formik,
  };
};

export { warehouseFilterStore, warehouseNavigationStore, useWarehouseFilters };
